export default __webpack_public_path__ + "assets/images/5093f8716a1dee38d97344389b395fc0.png";